// @ts-nocheck
import React from 'react';
import { makeStyles } from '@mui/styles';
import Box from '@mui/material/Box';
import Typography from "@mui/material/Typography";
import Divider from '@mui/material/Divider';
import SinapThemev2 from "../styles/SinapThemev2";
import useMediaQuery from '@mui/material/useMediaQuery';
import { ThemeProvider, styled } from '@mui/material/styles';
import { useTheme } from '@mui/material/styles';
import Alert from "@mui/material/Alert";
import ListaSOVPN from "./ListaSOVPN";
import QuizIcon from '@mui/icons-material/Quiz';

const useStyles = makeStyles(theme => ({
    typografy: {
        marginTop: '2%',
        width: "100%",
        color: SinapThemev2.palette.primary.main,
    }
}))

export default function ModuloVPN({ ...props }) {
    const classes = useStyles();
    const theme = useTheme();
    const matches = useMediaQuery('(min-width:1185px)');

    return (
        <Box paddingX="2%">
            <ThemeProvider theme={SinapThemev2}>
                <Typography fontSize={matches ? "30px" : "28px"} my="40px" mx="10px">
                    Certificados de VPN
                </Typography>
                <Divider />
                <br />
                <Alert severity="info">Aquí apareceran los distintos certificados asociados a su cuenta. Si tiene alguna
                    duda puede consultar las <b style={{ cursor: 'pointer' }} onClick={() => window.open('https://docs.frba.utn.edu.ar/books/mu---conexiones-remotas/page/preguntas-frecuentes-de-conexion-vpn-979', '_blank', 'noopener,noreferrer')}>Preguntas frecuentes <QuizIcon fontSize='small' /></b></Alert>

                <ListaSOVPN />

                <Divider />
                <br />
                <Alert severity="info">En caso de necesitar mas ayuda también puede <b>Contactarse con
                    Soporte</b></Alert>
                <br />
            </ThemeProvider>
        </Box>
    )
}